import { graphql, useStaticQuery } from "gatsby";

const Query = () => {
  return useStaticQuery(graphql`
    query {
      allContentfulMetodo {
        nodes {
          node_locale
          bottomLinkText
          bottomLinkUrl
          bottomImage {
            gatsbyImageData
            file {
              url
            }
          }
          bottomText {
            bottomText
          }
          text1 {
            text1
          }
          text2 {
            text2
          }
          text3 {
            text3
          }
          text4 {
            text4
          }
          title
          title1
          title2
          title3
          title4
          images1 {
            gatsbyImageData
            file {
              url
            }
          }
          images2 {
            gatsbyImageData
            file {
              url
            }
          }
          images3 {
            gatsbyImageData
            file {
              url
            }
          }
          images4 {
            gatsbyImageData
            file {
              url
            }
          }
          numbers {
            gatsbyImageData
            file {
              url
            }
            title
          }
        }
      }
    }
  `);
};

export default Query;
